import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
export class QuantitySelector {
  /**
   * Init needed events for quantity selector HTML elements from formular
   * @param {HTMLFormElement} form
   */
  constructor(form) {
    this.form = form;
    this.quantitySelector = form.querySelector('.js-input-counter');
    this.min = parseFloat(this.quantitySelector.getAttribute('min') || this.quantitySelector.dataset.min);
    this.minQuantity = this.min;
    this.max = parseFloat(this.quantitySelector.getAttribute('max') || this.quantitySelector.dataset.max);
    this.step = parseFloat(this.quantitySelector.getAttribute('data-step'));
    this.buttons = this.quantitySelector.parentElement.querySelectorAll('button');
    this.quantityLabelEl = form.querySelector('.js-quantity-label');
    _quantitySelectorEvent.call(this, this.quantitySelector);
    this.mode = '';
    if (form.querySelector('.js-unit-capacity-value')) {
      this.mode += '_DOUBLE_';
      this.initDouble();
    }
    if (form.querySelector('.js-floor-quantity')) {
      this.mode += '_FLOORING_';
      this.initFlooring();
    }
    const byQuantityEl = form.closest('.js-buy-box').querySelector('.js-by-quantity-selector');
    if (byQuantityEl) {
      this.mode += '_BY_QUANTITY_';
      this.initByQuantity(byQuantityEl);
    }
    this.form.dispatchEvent(new Event('USER_QUANTITY_UPDATED'));
  }
  initByQuantity(el) {
    new Carousel('#carouselByQuantity', {
      centerWhenNoButtons: true
    });
    this.values = [];
    this.checkboxsEl = el.querySelectorAll('.js-form-checkbox');
    for (let checkbox of this.checkboxsEl) {
      checkbox.addEventListener('change', e => this.updateFromCheckbox(e));
      this.values.push(Number.parseInt(checkbox.value));
    }
  }
  initDouble() {
    this.capacityValue = this.form.querySelector('.js-unit-capacity-value').value.replace(',', '.');
    this.inputCapacity = this.form.querySelector('.js-unit-capacity__input');

    // init inputCapacity
    _updateCapacity.call(this);
    // watch change on capacity input
    this.inputCapacity.addEventListener('keyup', () => {
      this.inputCapacity.value = this.inputCapacity.value.replace(/[^0-9,.]/g, '');
      _updateQuantity.call(this);
      _updateCapacity.call(this);
    });
  }
  initFlooring() {
    this.factor = this.form.querySelector('input[name="factor"]').value;
    this.unitPrice = this.form.querySelector('input[name="unitPrice"]').value;
    this.currency = this.form.querySelector('input[name="currency"]').value;
    this.totalAmount = this.form.querySelector('.js-total-amount');
    this.lengthValue = this.form.querySelector('.js-length-value');
    this.lengthLabel = this.form.querySelector('.js-length-label');
  }
  updateFromCheckbox(e) {
    if (e.target.checked) {
      this.quantitySelector.value = e.target.value;
    } else {
      this.quantitySelector.value = 1;
    }
    this.updateStep(this.quantitySelector.value);
    this.quantityLabelString = e.target.dataset.quantityLabelString;
    this.updateQuantityLabel();
    if (this.mode.includes('FLOORING')) {
      _setDatas.call(this);
    }
    if (this.mode.includes('DOUBLE')) {
      this.inputCapacity.disabled = !e.target.dataset.permitDouble || e.target.dataset.permitDouble !== "true";
      _updateCapacity.call(this);
    }
    this.updateCheckbox();
    _disableButtons.call(this);
  }
  updateQuantityLabel() {
    if (!this.quantityLabelString || !this.quantityLabelEl) {
      return;
    }
    this.quantityLabelEl.textContent = this.quantityLabelString.replace('{nbQuantity}', this.quantitySelector.value / this.step);
  }
  updateStep(step) {
    if (!step) {
      return;
    }
    if (step && !Number.isNaN(step)) {
      this.step = Number(step);
      if (step < this.minQuantity) {
        this.min = Number(this.minQuantity);
      } else {
        this.min = Number(step);
      }
      // FIXME why do I need it ?
      setTimeout(() => {
        _disableButtons.call(this);
      }, 0);
    }
  }
  updateCheckbox() {
    const closestValue = this._getClosestValue(Number.parseInt(this.quantitySelector.value));
    for (let checkbox of this.checkboxsEl) {
      checkbox.checked = false;
      if (closestValue && checkbox.value == closestValue) {
        checkbox.checked = true;
      }
    }
    _disableButtons.call(this);
  }
  _getClosestValue(inputValue) {
    const values = this.values.filter(element => element <= inputValue);
    if (values.length === 0) {
      return null;
    }
    return Math.max(...values);
  }
}

/**
 * _updateCapacity : update the capacity when quantity change
 */
function _updateCapacity() {
  try {
    this.quantitySelector.value = _acceptComma(this.quantitySelector.value);
    this.inputCapacity.value = this.quantitySelector.value * this.capacityValue;
    this.inputCapacity.value = Math.round(this.inputCapacity.value * 100) / 100;
    _disableButtons.call(this);
  } catch (error) {
    console.error('Error on updateQuantity', error);
  }
}

/**
 * _updateQuantity : update the quantity when capacity change
 */
function _updateQuantity() {
  try {
    this.inputCapacity.value = _acceptComma(this.inputCapacity.value);
    this.quantitySelector.value = Math.min(Math.ceil(this.inputCapacity.value / this.capacityValue), this.max);
    _disableButtons.call(this);
  } catch (error) {
    console.error('Error on updateCapacity', error);
  }
}
function _getFlooringFormatedString(value) {
  return `${(Math.round(value * this.unitPrice * 100) / 100).toFixed(2)} ${this.currency}`;
}
function _setDatas() {
  const length = Math.floor(_getNumberValue.call(this) / this.factor * 100) / 100;
  if (length > 1) {
    this.quantitySelector.value = this.quantitySelector.value;
    this.lengthValue.textContent = length.toFixed(2).replace(/[.,]00$/g, '');
    this.totalAmount.textContent = _getFlooringFormatedString.call(this, this.quantitySelector.value);
  } else {
    this.quantitySelector.value = this.min;
    this.lengthValue.textContent = "1";
    this.totalAmount.textContent = _getFlooringFormatedString.call(this, this.factor);
  }
  this.lengthLabel.textContent = length >= 2 ? window.productoffercdp?.translation?.mtrPlural?.toLowerCase() || '' : window.productoffercdp?.translation?.mtrSingular?.toLowerCase() || '';
}
function _quantitySelectorButtonsCallbacks() {
  if (this.mode.includes('FLOORING')) {
    _setDatas.call(this);
  }
  if (this.mode.includes('DOUBLE')) {
    this.inputCapacity.value = Math.round(parseInt(this.quantitySelector.value) * this.capacityValue * 100) / 100;
  }
  if (this.mode.includes('BY_QUANTITY')) {
    this.updateQuantityLabel();
  }
}

/**
 * Init event on input and element sibling near to it (buttons)
 */
function _quantitySelectorEvent() {
  _disableButtons.call(this);
  this.quantitySelector.addEventListener('focusout', () => {
    if (this.quantitySelector.value && this.quantitySelector.value < this.min) {
      this.quantitySelector.value = Number(this.min);
    } else if (this.quantitySelector.value % this.step !== 0) {
      this.quantitySelector.value = Math.round(this.quantitySelector.value / this.step) * this.step;
    }
    this.updateQuantityLabel();
    _disableButtons.call(this);
  });
  this.quantitySelector.addEventListener('keyup', () => {
    if (this.mode.includes('FLOORING')) {
      _setDatas.call(this);
    }
    if (this.mode.includes('DOUBLE')) {
      this.quantitySelector.value = this.quantitySelector.value.replace(/[^0-9]/g, '');
      _updateCapacity.call(this);
    }
    const value = _getNumberValue.call(this);
    this.quantitySelector.value = Math.max(value, this.min);
    this.quantitySelector.value = Math.min(value, this.max);
    _disableButtons.call(this);
  });
  this.buttons[0].addEventListener('click', event => {
    event.preventDefault();
    _decrement.call(this, this.step);
    _disableButtons.call(this);
    _quantitySelectorButtonsCallbacks.call(this);
  });
  this.buttons[1].addEventListener('click', event => {
    event.preventDefault();
    _increment.call(this, this.step);
    _disableButtons.call(this);
    _quantitySelectorButtonsCallbacks.call(this);
  });

  // Keyboard interaction
  //(https://www.w3.org/TR/wai-aria-practices-1.1/#spinbutton)
  this.quantitySelector.addEventListener('keydown', event => {
    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowLeft':
        event.preventDefault();
        _decrement.call(this, this.step);
        _disableButtons.call(this);
        break;
      case 'ArrowUp':
      case 'ArrowRight':
        event.preventDefault();
        _increment.call(this, this.step);
        _disableButtons.call(this);
        break;
      case 'PageUp':
        event.preventDefault();
        _increment.call(this, this.step * 5);
        _disableButtons.call(this);
        break;
      case 'PageDown':
        event.preventDefault();
        _decrement.call(this, this.step * 5);
        _disableButtons.call(this);
        break;
      case 'Home':
        event.preventDefault();
        _decrement.call(this, this.max);
        _disableButtons.call(this);
        break;
      case 'End':
        event.preventDefault();
        _increment.call(this, this.max);
        _disableButtons.call(this);
        break;
    }
  });
}

/**
 * Decrement the quantity by a specific amount
 */
function _decrement(amount) {
  const value = _getNumberValue.call(this);
  this.quantitySelector.value = Math.max(value - amount, this.min);
}

/**
 * Increment the quantity by a specific amount
 */
function _increment(amount) {
  const value = _getNumberValue.call(this);
  this.quantitySelector.value = Math.min(value + amount, this.max);
}

/**
 * Disabled buttons to step up or step down quantitySelector's value
 */
function _disableButtons() {
  this.form.dispatchEvent(new Event('USER_QUANTITY_UPDATED'));
  const value = _getNumberValue.call(this);
  switch (value) {
    case this.min:
      this.buttons[0].disabled = true;
      this.buttons[1].disabled = false;
      break;
    case this.max:
      this.buttons[0].disabled = false;
      this.buttons[1].disabled = true;
      break;
    default:
      this.buttons[0].disabled = false;
      this.buttons[1].disabled = false;
  }
  if (value + this.step > this.max) {
    this.buttons[0].disabled = false;
    this.buttons[1].disabled = true;
  }
}

/**
 * Return value with comma replace by point.
 * @returns {String}
 */
function _acceptComma(prmValue) {
  return prmValue.replace(/,/g, '.');
}

/**
 * Return the value of quantitySelector element passed as parameter
 * @returns {BigInt}
 */
function _getNumberValue() {
  return this.quantitySelector.value === '0' ? 0 : parseFloat(_acceptComma(this.quantitySelector.value)) || 1;
}